'use client';

import { useCapturePostHogException } from '@/components/entities/analytics/components/PostHog/hooks/useCapturePostHogException';
import { ErrorFallback } from '@/components/features/layout/ErrorFallback';

export default function ErrorBoundary(props: { error: Error & { digest?: string }; reset: () => void }) {
  useCapturePostHogException(props.error, 'route');

  return <ErrorFallback reset={props.reset} />;
}
